export default {
    'diagram3b4-5': {
        'diagram-task': 'Inductive',
        'diagram-peak': 'Creation of the Bank of England in 1694 was the result of a political compromise that became the basis of the financial systems of the world today',
        'diagram-hint': 'How did it work?',
        'diagram-answers': {
            '1': 'Bankers got the right to issue bank notes',
            '2': 'Provided reliable money as it was needed for commerce and war',
            '3': 'Ensured commercial management of the money over time',
            '4': 'Cash remains strictly a token of a credit held against the state',
            '5': 'Picked up worldwide as a good idea',
            '6': 'Created an adaptable model for interaction between states and bankers elsewhere'
        },
 //       'diagram-description': {
 //           '1': 'Provided reliable money as it was needed for commerce and war',
 //           '2': 'Bankers got the right to issue bank notes',
 //           '3': 'Ensured commercial management of the money over time',
 //           '4': 'Cash remains strictly a token of a credit held against the state',
 //           '5': 'Created an adaptable model for interaction between states and bankers elsewhere',
 //           '6': 'Picked up worldwide as a good idea',
 //       },
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b4/diagram5/i18n/en.js